export const hasError = {
  methods: {
    showGenericError() {
      this.$store.commit('snackbar/showMessage', {
        content: 'Server Error',
        color: 'error',
      });
    },
  },
};